// extracted by mini-css-extract-plugin
export default {"Container":"ErrorCode_Container__6guhM","box":"ErrorCode_box__LqlDE","printerNotSelected":"ErrorCode_printerNotSelected__xwuCl","dataNotFound":"ErrorCode_dataNotFound__kphOT"};